<div class="html-holder">
  @if (htmlIsLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <app-version-differ
    [showAdded]="showAdded"
    [showDeleted]="showDeleted"
    [versionHtml]="currentCompareHtml"></app-version-differ>
  <div class="button-holder">
    <button
      matTooltip="Show new changes"
      [class.activated-plus-button]="showAdded"
      mat-icon-button
      (click)="showAdded = !showAdded"
      color="accent">
      <mat-icon>add</mat-icon>
    </button>
    <button
      matTooltip="Show deleted"
      [class.activated-minus-button]="showDeleted"
      mat-icon-button
      (click)="showDeleted = !showDeleted"
      color="accent">
      <mat-icon>remove</mat-icon>
    </button>
  </div>
</div>
<div class="version-group-container">
  @if (isVersionsLoading$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <mat-form-field class="version-type">
    <mat-label>Version type</mat-label>
    <mat-select [formControl]="versionTypeSelector">
      <mat-option [value]="'all'">All</mat-option>
      <mat-option [value]="'onlyNamed'">Only named</mat-option>
    </mat-select>
  </mat-form-field>
  <cdk-accordion multi="true">
    @for (dayGroup of groupedVersions; track dayGroup.date; let index = $index) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        role="button"
        [expanded]="true"
        tabindex="0"
        [attr.id]="'accordion-header-' + index"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + index">
        <button class="date-group-header" (click)="accordionItem.toggle()">
          <div class="header-content">
            <mat-icon class="calendar-icon" fontIcon="calendar_today"></mat-icon>
            <h3>{{ dayGroup.date }}</h3>
          </div>
          <mat-icon class="expand-icon">{{ accordionItem.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        <div
          class="accordion-body"
          role="region"
          [@bodyExpansion]="accordionItem.expanded ? 'expanded' : 'collapsed'"
          [id]="'accordion-body-' + index">
          <div class="accordion-inner-content">
            @for (hourGroup of dayGroup.hourlyGroups; track hourGroup.hour) {
              <mat-list role="list" class="version-list">
                <app-version-list-item
                  [workspaceId]="workspaceId"
                  [version]="hourGroup.latestVersion"
                  [currentSelectedVersionId]="currentSelectedVersionId"
                  [isLatestInDate]="true"
                  [otherVersionsCount]="hourGroup.otherVersions.length"
                  [isExpanded]="hourGroup.isExpanded"
                  (versionClicked)="onVersionClick($event)"
                  [noVersionToCompare]="isFirstVersionId === hourGroup.latestVersion.version_id"
                  (expandToggled)="toggleHourExpansion(hourGroup)"></app-version-list-item>
              </mat-list>

              @if (hourGroup.isExpanded) {
                <div class="expanded-list-wrapper">
                  <mat-list role="list" class="version-list expanded-versions">
                    @for (version of hourGroup.otherVersions; track version.version_id) {
                      <app-version-list-item
                        [version]="version"
                        [workspaceId]="workspaceId"
                        [currentSelectedVersionId]="currentSelectedVersionId"
                        [isLatestInDate]="false"
                        [noVersionToCompare]="isFirstVersionId === version.version_id"
                        (versionClicked)="onVersionClick($event)"></app-version-list-item>
                    }
                  </mat-list>
                </div>
              }
            }
          </div>
        </div>
      </cdk-accordion-item>
    } @empty {
      <div class="no-data-message">No document versions found.</div>
    }
  </cdk-accordion>
</div>
